import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    title: "",
    description: "",
    actions: []
}

const proposalSlice = createSlice({
    name: 'proposal',
    initialState,
    reducers: {
        setTitle(state, action) {
            state.title = action.payload;
        },
        setDescription(state, action) {
            state.description = action.payload;
        },
        addAction(state, action) {
            state.actions.push(action.payload);
        },
        editAction(state, action) {
            state.actions[action.payload.index] = action.payload.action;
        },
        deleteAction(state, action) {
            state.actions.splice(action.payload, 1);
        },
        clearProposal(state) {
            state = initialState;
        }
    },
});

export const {
    setTitle,
    setDescription,
    addAction,
    editAction,
    deleteAction,
    clearProposal
} = proposalSlice.actions;
export default proposalSlice.reducer;

